import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import Hamburger from '@/components/Hamburger';
import downloadCenter from '@/views/downLoadCenter/downLoadCenterList';
import ArtilleryFirelist from '@/views/downLoadCenter/artilleryFirelist.vue';
import NoticeCenter from '@/views/manageCenter/announcementManagement/noticeCenter/index.vue';
import BindWecomDialog from '@/views/user/components/bindWecomDialog.vue';
import { getAnnouncementRecentStats } from '@/api/manageCenter';
import { getEnterpriseWechatAuth } from '@/api/user';
export default {
  components: {
    ArtilleryFirelist: ArtilleryFirelist,
    Hamburger: Hamburger,
    downloadCenter: downloadCenter,
    NoticeCenter: NoticeCenter,
    BindWecomDialog: BindWecomDialog
  },
  data: function data() {
    return {
      showDropdown: false,
      servicePopShow: false,
      drawer: false,
      drawerFire: false,
      // 公告中心抽屉
      drawerNotice: false,
      // 小铃铛公告数量
      noticeTotal: {},
      // 绑定企业微信弹窗
      bindWecomVisible: false,
      // 绑定企业微信入口是否展示（由后端接口返回决定）
      showBindWecom: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['sidebar', 'avatar', 'userInfo', 'head', 'serviceName'])), {}, {
    // 当班客服列表（接口 as_array=1 返回数组）
    serviceList: function serviceList() {
      return Array.isArray(this.serviceName) ? this.serviceName : [];
    }
  }),
  created: function created() {
    this.getNoticeTotal();
    this.getBindWecomVisible();
    // 首页弹框阅读/回执后：overview 与 Navbar 非父子组件，经 $root 事件总线通知重新拉取小铃铛数量
    this.$root.$on('announcement-stat-change', this.getNoticeTotal);
  },
  beforeDestroy: function beforeDestroy() {
    this.$root.$off('announcement-stat-change', this.getNoticeTotal);
  },
  watch: {
    userInfo: {
      immediate: true,
      handler: function handler(val, oldVal) {
        var _this = this;
        if (val.nick_name) {
          this.$watermark.content = val.nick_name;
          setTimeout(function () {
            _this.$watermark.create();
          }, 500);
        }
      }
    }
  },
  methods: {
    // 获取小铃铛公告数量
    getNoticeTotal: function getNoticeTotal() {
      var _this2 = this;
      getAnnouncementRecentStats().then(function (res) {
        var data = res.data || {};
        _this2.noticeTotal = res.data;
      }).catch(function () {
        _this2.noticeTotal = 0;
      });
    },
    // 公告中心内阅读/回执后：本地同步顶部未读/未回执统计与铃铛徽标，不额外调接口
    handleNoticeStatChange: function handleNoticeStatChange(_ref) {
      var _ref$unreadDelta = _ref.unreadDelta,
        unreadDelta = _ref$unreadDelta === void 0 ? 0 : _ref$unreadDelta,
        _ref$unCallbackDelta = _ref.unCallbackDelta,
        unCallbackDelta = _ref$unCallbackDelta === void 0 ? 0 : _ref$unCallbackDelta,
        _ref$pendingDelta = _ref.pendingDelta,
        pendingDelta = _ref$pendingDelta === void 0 ? 0 : _ref$pendingDelta;
      this.getNoticeTotal();
    },
    // 公告中心：打开侧滑抽屉
    goNotice: function goNotice() {
      this.drawerNotice = true;
    },
    openLiyue: function openLiyue() {
      window.open(this.head.shop);
    },
    openFenx: function openFenx() {
      window.open(this.head.funshare);
    },
    openBeis: function openBeis() {
      window.open(this.head.iTalent);
    },
    toggleDropdown: function toggleDropdown(visible) {
      this.showDropdown = visible;
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
      // console.log(`[src/layout/components/Navbar.vue]L179 this.$store.state.app.sidebar.opened=`,this.$store.state.app.sidebar.opened)
    },
    changePassword: function changePassword() {
      this.$router.push({
        name: 'changePassword'
      });
    },
    // 是否展示绑定企业微信入口，由后端接口判断；失败时保持不展示
    getBindWecomVisible: function getBindWecomVisible() {
      var _this3 = this;
      getEnterpriseWechatAuth({
        source: 'enterpriseWechat'
      }).then(function (res) {
        _this3.showBindWecom = !res.data;
      }).catch(function () {
        _this3.showBindWecom = false;
      });
    },
    // 绑定企业微信
    bindWecom: function bindWecom() {
      this.bindWecomVisible = true;
    },
    // 更改系统模式
    goSystem: function goSystem() {
      this.$router.push({
        name: 'changeSystem'
      });
    },
    // 烽火雷达
    artilleryRadar: function artilleryRadar() {
      this.drawerFire = true;
    },
    logout: function logout() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this4.$store.dispatch('user/logout');
            case 1:
              _this4.$router.replace({
                path: '/login'
              });
              // window.location.href = '#/login'
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    // 下载中心
    goDown: function goDown() {
      this.drawer = true;
      // let src = window.location.origin
      // console.log(window.location.origin)
      // // let src = ''
      // if (process.env.VUE_APP_NAME === 'production') {
      //   src = `${src}/#/downLoadCenter/downLoadCenter`
      // } else if (process.env.VUE_APP_NAME === 'test') {
      //   src = `${src}/#/downLoadCenter/downLoadCenter`
      // } else {
      //   src = `${src}/#/downLoadCenter/downLoadCenter`
      // }
      // window.open(src, '_blank')
      // // this.$router.push({
      // //   name: 'downLoadCenter'
      // // })
    },
    uploadAvatar: function uploadAvatar() {
      this.$router.push({
        name: 'uploadAvatar'
      });
    }
  }
};